import { EXECUTE_FX } from './balance'

// ビート順: impact → pull(魂を抜く) → dissolve(ボスが灰に) → absorb(主人公が閃く) → silence(余韻)
// 描画(render.ts)は連続ストリームとして繋ぐためこの境界を時刻として使う (export)。
export const T_PULL = EXECUTE_FX.impactHitStopMs
export const T_DISSOLVE = T_PULL + EXECUTE_FX.pullDurationMs
export const T_ABSORB = T_DISSOLVE + EXECUTE_FX.dissolveMs
export const T_SILENCE = T_ABSORB + EXECUTE_FX.absorbFlashMs
export const T_END = T_SILENCE + EXECUTE_FX.silenceBeatMs

export type FinisherBeat = 'impact' | 'pull' | 'absorb' | 'dissolve' | 'silence'

export function finisherBeat(elapsedMs: number): FinisherBeat {
  if (elapsedMs < T_PULL) return 'impact'
  if (elapsedMs < T_DISSOLVE) return 'pull'
  if (elapsedMs < T_ABSORB) return 'dissolve'
  if (elapsedMs < T_SILENCE) return 'absorb'
  return 'silence'
}

export function finisherTimeScale(elapsedMs: number): number {
  // impact: 通常速 (鋭い着弾) → pull: スロー (魂を味わう) →
  // dissolve: スロー→通常へ smoothstep で滑らかに復帰 (速度の段差を消す) → 以降通常。
  if (elapsedMs < T_PULL) return 1
  if (elapsedMs < T_DISSOLVE) return EXECUTE_FX.pullTimeScale
  if (elapsedMs < T_ABSORB) {
    const t = (elapsedMs - T_DISSOLVE) / EXECUTE_FX.dissolveMs
    const e = t * t * (3 - 2 * t)
    return EXECUTE_FX.pullTimeScale + (1 - EXECUTE_FX.pullTimeScale) * e
  }
  return 1
}

export function finisherDone(elapsedMs: number): boolean {
  return elapsedMs >= T_END
}

export function beatProgress(elapsedMs: number): number {
  const b = finisherBeat(elapsedMs)
  if (b === 'pull') return (elapsedMs - T_PULL) / EXECUTE_FX.pullDurationMs
  if (b === 'dissolve') return (elapsedMs - T_DISSOLVE) / EXECUTE_FX.dissolveMs
  if (b === 'absorb') return (elapsedMs - T_ABSORB) / EXECUTE_FX.absorbFlashMs
  if (b === 'silence') return (elapsedMs - T_SILENCE) / EXECUTE_FX.silenceBeatMs
  return 0
}
